import { render } from "./Slides.vue?vue&type=template&id=6d30e6f6"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__